export default __webpack_public_path__ + "files/MaxStockDM.f6de2dad.pdf";